import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import { strToEl } from 'data/function';
import SadBlip from 'assets/img/sad-blip.svg';
let FragmentLoaderComponent = class FragmentLoaderComponent {
    static $inject = ['$compile', '$scope'];
    constructor($compile, $scope) {
        'ngInject';
        this.$compile = $compile;
        this.$scope = $scope;
        this.iframeLoaded = false;
        this.isFragmentBinded = false;
        this.allowCheck = this.allowCheck === undefined ? true : false;
    }
    async $onInit() {
        await this.bindFragmentElement();
    }
    async $onChanges(changes) {
        if (changes.src?.previousValue !== changes.src?.currentValue && !this.isFragmentBinded) {
            await this.bindFragmentElement();
        }
    }
    async bindFragmentElement() {
        const iframe = strToEl(`<iframe src="${this.src}"
            id="${this.frameName}"
            name="${this.frameName}"
            width="100%"
            height="100%"
            scrolling="no"
            ng-onload="$ctrl.onIframeLoad()"
            frameborder="0"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"></iframe>`);
        const errorContent = strToEl(`<div class="flex flex-column items-center justify-center u-full-width">
            <h1>${this.errorMessage}</h1>
            <img src="${SadBlip}" />
            </div>`);
        const containerContent = await this.isOk()
            ? iframe
            : (() => {
                this.onIframeError();
                return errorContent;
            })();
        setTimeout(() => {
            const compiledElement = this.$compile(containerContent)(this.$scope);
            const container = document.getElementById(`${this.frameName}-container`);
            if (container.lastElementChild) {
                container.removeChild(container.lastElementChild);
            }
            container.appendChild(compiledElement[0]);
        });
        this.isFragmentBinded = true;
    }
    /**
     * Check health of iframe url
     */
    async isOk() {
        if (!this.allowCheck) {
            return true;
        }
        try {
            await fetch(this.src, {
                method: 'GET',
                mode: 'no-cors',
            });
            return true;
        }
        catch (err) {
            console.error(err);
            this.onIframeError();
            return false;
        }
    }
    /**
     * Callback executed when occurs some error with iframe
     */
    onIframeError() {
        if (this.onError) {
            this.onError();
        }
        this.iframeLoaded = false;
    }
    /**
     * Callback executed when iframe is loaded
     */
    onIframeLoad() {
        if (this.onLoad) {
            this.onLoad();
        }
        this.iframeLoaded = true;
    }
};
FragmentLoaderComponent.$inject = ['$compile', '$scope'];
FragmentLoaderComponent = __decorate([
    Component({
        template: `
    <div class="min-h-100 flex" id="{{$ctrl.frameName}}-container"></div>
    `,
        bindings: {
            frameName: '@?',
            src: '@?',
            errorMessage: '@?',
            onLoad: '&?',
            onError: '&?',
            allowCheck: '<?',
        },
    }),
    __metadata("design:paramtypes", [Object, Object])
], FragmentLoaderComponent);
export { FragmentLoaderComponent };
